export default function Appbar(theme) {
  return {
    MuiAppBar: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z20,
        },
      },
    },
  };
}
